import { Button } from '@repo/shadcn';
import { Loader2Icon } from 'lucide-react';
import { useFormContext } from 'react-hook-form';

import { IwForm } from '@components/form';

import {
    AddPaymentFormSchema,
    INITIAL_VALUE,
    TAddPaymentForm,
} from '@/modules/cart/add-payment-form.schema.ts';
import { AddPayment } from '@/modules/cart/add-payment.component.tsx';

import { useSupplierDetailsContext } from './context';

const AddSupplierPaymentComponent = () => {
    const { data, isPaymentLoading } = useSupplierDetailsContext();
    const { watch } = useFormContext<TAddPaymentForm>();

    const payments = watch('payments');

    const formTotal =
        payments?.reduce(
            (total, payment) => total + (payment.amount ?? 0),
            0,
        ) ?? 0;

    const isPaid = data?.data?.total_due === 0;
    // const totalPrice = data?.data?.payment?.total_price ?? 0;
    // const totalPaid = data?.data?.payment?.total_paid ?? 0;

    const dueAmount = data?.data?.total_due ?? 0;
    const isButtonDisabled = isPaymentLoading || isPaid || formTotal === 0;

    if (isPaid) {
        return null;
    }

    return (
        <div className="min-w-0 [&_.mt-4>*]:w-full [&_.mt-4]:flex-col [&_.mt-4]:gap-2 sm:[&_.mt-4]:flex-row sm:[&_.mt-4]:gap-4 [&_.mt-4_[role=combobox]]:w-full [&_h3]:items-start [&_h3]:gap-1 [&_h3]:text-xl sm:[&_h3]:flex-row sm:[&_h3]:items-center sm:[&_h3]:text-2xl">
            <AddPayment totalPrice={dueAmount} multiplePayments={false}>
                <div className={'flex justify-end'}>
                    <Button
                        disabled={isButtonDisabled}
                        className="flex w-full items-center justify-center sm:w-auto"
                    >
                        {isPaymentLoading ? (
                            <>
                                <Loader2Icon />
                                Loading...
                            </>
                        ) : (
                            'Confirm Payment'
                        )}
                    </Button>
                </div>
            </AddPayment>
        </div>
    );
};

export const AddSupplierPayment = () => {
    const { handleAddSupplierPayment, paymentFormRef } =
        useSupplierDetailsContext();
    return (
        <IwForm
            schema={AddPaymentFormSchema}
            initialValues={INITIAL_VALUE}
            ref={paymentFormRef}
            onSubmit={(data) => {
                handleAddSupplierPayment(data as TAddPaymentForm);
            }}
        >
            <AddSupplierPaymentComponent />
        </IwForm>
    );
};

AddSupplierPayment.displayName = 'AddSupplierPayment';
